import { type File } from '@littlebird/sdk';

import { Icons } from '@/assets/icons/icons';
import { IconButton } from '@/components/ui';
import { DropdownMenu } from '@/components/ui/dropdown-menu';
import { inDesktop } from '@/utils/capabilities';

import { useCanvasExport } from './useCanvasExport';

import type { CanvasExportFormat } from '../../../electron/shared';

type CanvasExportMenuProps = {
  file: File;
  size?: 'sm' | 'md';
};

const FORMAT_LABELS: Record<CanvasExportFormat, string> = {
  png: 'Download as image',
  pdf: 'Download as PDF',
};

const DesktopCanvasExportMenu = ({
  file,
  size = 'sm',
}: CanvasExportMenuProps) => {
  const { isExporting, runExport } = useCanvasExport(file);

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <IconButton
          size={size}
          icon={isExporting ? Icons.loader : Icons.download}
          tooltip="Download"
          aria-label="Download canvas"
          disabled={isExporting}
        />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="end">
        {(['png', 'pdf'] as const).map((format) => (
          <DropdownMenu.Item
            key={format}
            onSelect={() => void runExport(format)}
          >
            {FORMAT_LABELS[format]}
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};

export const CanvasExportMenu = (props: CanvasExportMenuProps) =>
  inDesktop() ? <DesktopCanvasExportMenu {...props} /> : null;
